export const API_ENDPOINTS = {

    SHIFT_MASTER: {
        ADD_SHIFT_MASTER: () => `/shift-master`,
        FETCH_SHIFT_TYPE: () => `/shift-master/type`,
        FETCH_SHIFT_MASTER: `/shift-master`,

        UPDATE_SHIFT_MASTER: (id) => `shift-master/${id}`,
        // /shift-master/sample-download
        GET_SHIFT_MASTER_SAMPLE: () => `/shift-master/sample`,

        DELETE_SHIFT:(id) => `/shift-master/${id}`,

        BULK_UPLOAD: () => `/shift-master/import`,
    }

}